import { Chip, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { SpeakerNote } from '../../../../icons/speaker-notes';
import { style } from './style';

type EngagementStatusChipProps = {
  reason: string,
  details: string,
  label: string,
}

export const CloseStatusChip = ({
  label,
  reason,
  details,
}:EngagementStatusChipProps):JSX.Element => {
  return (
    <Box style={ style.chip.container }>
      <Chip
        sx={ style.chip.sx }
        label={ label }
        icon={ (
          <SpeakerNote
            viewBox="0 0 24 24"
          />
        ) }
      />
      <Box>
        <Typography
          variant="body1"
          className="status-block_text"
          style={ style.Typography.body1 }
        >
          { reason }
        </Typography>
        <Typography
          variant="caption"
          sx={ style.Typography.caption }
        >
          {details}
        </Typography>
      </Box>
    </Box>
  );
};
